import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import authSelector from 'modules/Auth/selectors'
import SuccessMessage from 'utils/SuccessMessage'
import corporateRequest from 'utils/corporateRequest'
import moment from 'moment'

// Utility function to get current financial year
const getCurrentFinancialYear = () => {
  const currentYear = moment().year()
  const currentMonth = moment().month()
  if (currentMonth < 3) {
    return `${currentYear - 1}-${currentYear}`
  } else {
    return `${currentYear}-${currentYear + 1}`
  }
}

// Action Types
export const SET_LATEST_ROLES_DATA = 'corporateDashboardPage2/SET_LATEST_ROLES_DATA'
export const SET_JOBTYPE_DATA = 'corporateDashboardPage2/SET_JOBTYPE_DATA'
export const SET_METRICS_DATA = 'corporateDashboardPage2/SET_METRICS_DATA'
export const SET_DEGREE_CHART_DATA = 'corporateDashboardPage2/SET_DEGREE_CHART_DATA'
export const SET_INSTITUTE_CHART_DATA = 'corporateDashboardPage2/SET_INSTITUTE_CHART_DATA'
export const SET_LOCATION_CHART_DATA = 'corporateDashboardPage2/SET_LOCATION_CHART_DATA'
export const SET_FINANCIAL_YEAR_DATA = 'corporateDashboardPage2/SET_FINANCIAL_YEAR_DATA'
export const SET_STAGES_CHART_DATA = 'corporateDashboardPage2/SET_STAGES_CHART_DATA'

// Loading Action Types
export const SET_DEGREE_CHART_LOADING = 'corporateDashboardPage2/SET_DEGREE_CHART_LOADING'
export const SET_LOCATION_CHART_LOADING = 'corporateDashboardPage2/SET_LOCATION_CHART_LOADING'
export const SET_INSTITUTE_CHART_LOADING = 'corporateDashboardPage2/SET_INSTITUTE_CHART_LOADING'

// Action Creators
export const setLatestRolesData = data => {
  return {
    type: SET_LATEST_ROLES_DATA,
    data,
  }
}

export const setJobtypeData = data => {
  return {
    type: SET_JOBTYPE_DATA,
    data,
  }
}

export const setMetricsData = data => {
  return {
    type: SET_METRICS_DATA,
    data,
  }
}

export const setDegreeChartData = data => {
  return {
    type: SET_DEGREE_CHART_DATA,
    data,
  }
}

export const setInstituteChartData = data => {
  return {
    type: SET_INSTITUTE_CHART_DATA,
    data,
  }
}

export const setLocationChartData = data => {
  return {
    type: SET_LOCATION_CHART_DATA,
    data,
  }
}

export const setFinancialYearData = data => {
  return {
    type: SET_FINANCIAL_YEAR_DATA,
    data,
  }
}

export const setStagesChartData = data => {
  return {
    type: SET_STAGES_CHART_DATA,
    data,
  }
}

export const setDegreeChartLoading = loading => {
  return {
    type: SET_DEGREE_CHART_LOADING,
    loading,
  }
}

export const setLocationChartLoading = loading => {
  return {
    type: SET_LOCATION_CHART_LOADING,
    loading,
  }
}

export const setInstituteChartLoading = loading => {
  return {
    type: SET_INSTITUTE_CHART_LOADING,
    loading,
  }
}

// API Actions
export const getLatestRoles = () => async (dispatch, getState) => {
  console.log("getLatestRoles")
  const state = getState()
  const corporateId = authSelector.getCorporateId(state)
  
  try {
    const result = await corporateRequest.get(
      `/corporates/${corporateId}/dashboard/latest-roles`
    )
    dispatch(setLatestRolesData(result?.data?.data || {}))
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch latest roles')
    return error
  }
}

export const getJobtypeData = () => async (dispatch, getState) => {
  console.log("getJobtypeData")
  const state = getState()
  const corporateId = authSelector.getCorporateId(state)
  
  try {
    const result = await corporateRequest.get(
      `/corporates/${corporateId}/dashboard/jobtype`
    )
    dispatch(setJobtypeData(result?.data?.data || {}))
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch jobtype data')
    return error
  }
}

// Helper function to convert filter key to API jobtype value
const convertFilterToJobtype = (filter) => {
  switch (filter) {
    case "JOBS":
      return "PLACEMENT";
    case "INTERNSHIP":
      return "INTERNSHIP";
    case "APPRENTICESHIP":
      return "APPRENTICESHIP";
    case "PROJECTS":
      return "GIGS";
    case "INTERNSHIP_PPO":
      return "INTERNSHIP_PPO";
    default:
      return "PLACEMENT";
  }
};

export const getMetricsData = (filter = "JOBS", financialYear = null) => async (dispatch, getState) => {
  console.log("getMetricsData", filter, financialYear)
  const state = getState()
  const corporateId = authSelector.getCorporateId(state)
  const jobtype = convertFilterToJobtype(filter)
  
  let url = `/corporates/${corporateId}/dashboard/metrices?jobtype=${jobtype}`
  if (financialYear && financialYear.length === 2) {
    const startDate = financialYear[0].format('YYYY-MM-DD')
    const endDate = financialYear[1].format('YYYY-MM-DD')
    url += `&startDate=${startDate}&endDate=${endDate}`
  }
  
  try {
    const result = await corporateRequest.get(url)
    dispatch(setMetricsData(result?.data?.data || {}))
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch metrics data')
    return error
  }
}

export const getDegreeChartData = (filter = "JOBS", financialYear = null) => async (dispatch, getState) => {
  console.log("getDegreeChartData", filter, financialYear)
  const state = getState()
  const corporateId = authSelector.getCorporateId(state)
  const jobtype = convertFilterToJobtype(filter)
  
  dispatch(setDegreeChartLoading(true))
  
  let url = `/corporates/${corporateId}/dashboard/degree-chart?jobtype=${jobtype}`
  if (financialYear && financialYear.length === 2) {
    const startDate = financialYear[0].format('YYYY-MM-DD')
    const endDate = financialYear[1].format('YYYY-MM-DD')
    url += `&startDate=${startDate}&endDate=${endDate}`
  }
  
  try {
    const result = await corporateRequest.get(url)
    dispatch(setDegreeChartData(result?.data?.data || {}))
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch degree chart data')
    return error
  } finally {
    dispatch(setDegreeChartLoading(false))
  }
}

export const getInstituteChartData = (filter = "JOBS", financialYear = null, isApplicant = true) => async (dispatch, getState) => {
  console.log("getInstituteChartData", filter, financialYear, isApplicant)
  const state = getState()
  const corporateId = authSelector.getCorporateId(state)
  const jobtype = convertFilterToJobtype(filter)
  
  dispatch(setInstituteChartLoading(true))
  
  let url = `/corporates/${corporateId}/dashboard/institute-chart?jobtype=${jobtype}&isApplicant=${isApplicant}`
  if (financialYear && financialYear.length === 2) {
    const startDate = financialYear[0].format('YYYY-MM-DD')
    const endDate = financialYear[1].format('YYYY-MM-DD')
    url += `&startDate=${startDate}&endDate=${endDate}`
  }
  
  try {
    const result = await corporateRequest.get(url)
    dispatch(setInstituteChartData(result?.data?.data || {}))
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch institute chart data')
    return error
  } finally {
    dispatch(setInstituteChartLoading(false))
  }
}

export const getLocationChartData = (filter = "JOBS", isPermanentLocation = false, isState = false, financialYear = null) => async (dispatch, getState) => {
  const state = getState()
  const corporateId = authSelector.getCorporateId(state)
  const jobtype = convertFilterToJobtype(filter)
  
  dispatch(setLocationChartLoading(true))
  
  let url = `/corporates/${corporateId}/dashboard/location-chart?jobtype=${jobtype}&isPermanentLocation=${isPermanentLocation}&isState=${isState}`
  if (financialYear && financialYear.length === 2) {
    const startDate = financialYear[0].format('YYYY-MM-DD')
    const endDate = financialYear[1].format('YYYY-MM-DD')
    url += `&startDate=${startDate}&endDate=${endDate}`
  }
  
  try {
    const result = await corporateRequest.get(url)
    dispatch(setLocationChartData(result?.data?.data || {}))
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch location chart data')
    return error
  } finally {
    dispatch(setLocationChartLoading(false))
  }
}

export const getFinancialYearData = (financialYear = null) => async (dispatch, getState) => {
  console.log("getFinancialYearData", financialYear)
  const state = getState()
  const corporateId = authSelector.getCorporateId(state)
  
  let url = `/corporates/${corporateId}/dashboard/financial-year`
  if (financialYear && financialYear.length === 2) {
    const startDate = financialYear[0].format('YYYY-MM-DD')
    const endDate = financialYear[1].format('YYYY-MM-DD')
    url += `&startDate=${startDate}&endDate=${endDate}`
  }
  
  try {
    const result = await corporateRequest.get(url)
    // Extract the years array from the response data
    const financialYearData = {
      message: result?.data?.message || "Success",
      years: result?.data?.data?.years || [],
      error: result?.data?.error || {}
    }
    dispatch(setFinancialYearData(financialYearData))
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch financial year data')
    return error
  }
}

export const getStagesChartData = (filter = "JOBS", financialYear = null) => async (dispatch, getState) => {
  console.log("getStagesChartData", filter, financialYear)
  const state = getState()
  const corporateId = authSelector.getCorporateId(state)
  const jobtype = convertFilterToJobtype(filter)
  
  let url = `/corporates/${corporateId}/dashboard/stages-chart?jobtype=${jobtype}`
  if (financialYear && financialYear.length === 2) {
    const startDate = financialYear[0].format('YYYY-MM-DD')
    const endDate = financialYear[1].format('YYYY-MM-DD')
    url += `&startDate=${startDate}&endDate=${endDate}`
  }
  
  try {
    const result = await corporateRequest.get(url)
    dispatch(setStagesChartData(result?.data?.data || {}))
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch stages chart data')
    return error
  }
}